import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';

import { catchError, throwError } from 'rxjs';

import { CookieAuthService } from 'src/app/@shared/storage-variables/cookie-auth.service';
import { environment } from 'src/environments/environment';

import { GraphQLHttpErrorBody } from '../models/graphQL/graphql-http-error.model';
const LOGIN_ROUTE = '/login';
const UNAUTHORIZED_CODE = 'UNAUTHORIZED';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const cookieAuthService = inject(CookieAuthService);
  const router = inject(Router);

  const isOurApiUrl = (url: string) => url.startsWith(environment.base_api_url);

  if (!isOurApiUrl(req.url)) {
    return next(req);
  }

  const token = cookieAuthService.getToken;

  if (!token) {
    return next(req);
  }

  const authReq = req.clone({
    headers: req.headers.set('authorization', `Bearer ${token}`),
  });

  const handleUnauthorized = (error: HttpErrorResponse) => {
    cookieAuthService.resetAuthVariables();
    router.navigate([LOGIN_ROUTE]);
    return throwError(() => error);
  };

  return next(authReq).pipe(
    catchError((error: HttpErrorResponse) => {
      const body = error?.error as GraphQLHttpErrorBody | undefined;
      const isGraphqlUnauthorized = body?.errors?.some(
        (err) => err.extensions?.code === UNAUTHORIZED_CODE,
      );

      if (isGraphqlUnauthorized || error.status === 401) {
        return handleUnauthorized(error);
      }
      return throwError(() => error);
    }),
  );
};
